module.exports = __webpack_public_path__ + "static/media/Iconos_ON.877f8bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/Iconos_ON.png
// module id = 71
// module chunks = 0